import { useEffect } from "react";
import { SavedResourceSchema, SearchFilterOptionType } from "../../../data/types";
// import { ReactComponent as OrderIcon } from '../../icons/OrderIcon.svg'
import SavedResourceCard from "../../../components/Desktop/SavedResourceCard";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Pagination from "../../../components/Desktop/Pagination";
import { usePagination } from "../../../hooks/paginationhooks";

// import BookedResourceCard from "../../components/BookedResourceCard";
import {
  useCompleteSignIn,
  // useLoadBookings,
  useUpdateAccountDetails,
} from "../../../hooks/authhooks";
import { useNavigate } from "react-router-dom";
import { useLoadResourcesFilter, useLoadSavedResources } from "../../../hooks/apphooks";
// import { BookingDetailsModal } from '../../../molecules/Desktop/AppModal';


type SavedResourceListingProps = {
  searchFilterOptions: SearchFilterOptionType
}

const SavedResourceListing: React.FC<SavedResourceListingProps> = ({ searchFilterOptions }) => {
  const { user } = useCompleteSignIn();
  const navigate = useNavigate();
  const { searchTerm, currentFilter } = searchFilterOptions;
  
  // Get saved resources from user object
  const rawSavedResources: SavedResourceSchema[] =
    user && user?.saved_resources ? user.saved_resources : [];
  
  // Fetch full resource details for saved resources to ensure complete data
  const { enrichedSavedResources: allSavedResources, isLoading: isLoadingSavedResources } = useLoadSavedResources(rawSavedResources);
  
  // const [filterSetting, setFilterSetting] = useState<boolean>(false);
  // const [currentSavedResourcePage, setCurrentSavedResourcePage] = useState(1);

  var filteredSavedResources = allSavedResources
    ? allSavedResources.filter(
        (resource) =>
          resource?.state?.toLowerCase() ===
            currentFilter.state.toLowerCase() ||
          resource?.state === "" ||
          currentFilter.state === ""
      )
    : [];


  var { searchSavedResources } = useLoadResourcesFilter(
    "kitchen",
    currentFilter.state,
    currentFilter.active
  );

  if (searchTerm) {
    const { searchedResources } = searchSavedResources(searchTerm, filteredSavedResources);
    filteredSavedResources = searchedResources;
  }

  const {
    currentPage,
    setCurrentPage,
    paginatedItems: paginatedResources,
    startIndex,
    endIndex,
    totalItems: numSavedResources,
    itemsPerPage
  } = usePagination(filteredSavedResources);

  // useEffect(() => {
  //   document.title = `HomeCook | Saved Resources Listing`
  // })

  // const [width, setWidth] = useState(window.innerWidth);

  // function handleWindowSizeChange() {
  //   setWidth(window.innerWidth);
  // }
  useEffect(() => {
    document.title = `HomeCook | Saved Resources Listing`;
    // window.addEventListener("resize", handleWindowSizeChange);
    // return () => {
    //   window.removeEventListener("resize", handleWindowSizeChange);
    // };
  }, []);


  // const loggedin_username = user?.username ? user?.username : "";
  const loggedinUid = user?.uid ? user?.uid : "";
  const { removeResource } = useUpdateAccountDetails(loggedinUid);

  const handleRemoveSavedResource = (resource_id: string | undefined) => {
    if (resource_id) {
      removeResource(resource_id);
    }
  };

  // var { bookings } = useLoadBookings(loggedin_username);
  // bookings = bookings ? bookings : [];


  // const {
  //   currentPage: bookingsCurrentPage,
  //   setCurrentPage: setBookingsCurrentPage,
  //   paginatedItems: paginatedBookings,
  //   startIndex: bookingsStartIndex,
  //   endIndex: bookingsEndIndex,
  //   totalItems: numBookings,
  //   itemsPerPage: bookingsPerPage
  // } = usePagination(bookings);

  // type savedResourcePageOptionsType = {
  //   id: "saved" | "booked"
  //   name: string;
  // }
  // const savedResourcePageOptions: savedResourcePageOptionsType[] = [
  //   {
  //     id: "saved",
  //     name: `Saved (${allSavedResources.length})`,
  //   },
  //   {
  //     id: "booked",
  //     name: `Bookings and Reservations (${bookings.length})`,
  //   },
  // ];

  // const [currentOption, setCurrentOption] = useState("saved");
  // const resourcesPerPage = 6;
  // var startIndex = 0;
  // var endIndex =
  //   numSavedResources <= resourcesPerPage
  //     ? numSavedResources
  //     : resourcesPerPage;
  // var numPages = Math.ceil(numSavedResources / resourcesPerPage);

  // Add state for modal
  // const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState<ResourceBookingSchema | null>(null);
  // const [isEditMode, setIsEditMode] = useState(false);

  // const handleViewDetails = (booking: ResourceBookingSchema) => {
  //   setSelectedBooking(booking);
  //   setIsEditMode(false);
  //   setIsBookingModalOpen(true);
  // };

  // const handleEditDetails = (booking: ResourceBookingSchema) => {
  //   setSelectedBooking(booking);
  //   setIsEditMode(true);
  //   setIsBookingModalOpen(true);
  // };

  // const handleCloseBookingModal = () => {
  //   setIsBookingModalOpen(false);
  //   setSelectedBooking(null);
  //   setIsEditMode(false);
  // };

    return (
      <>
        <div
          className={`w-full left-0 flex font-open-sans h-full overflow-y-scroll relative  top-0 justify-center bg-gradient-to-b from-[#F5F5F5] pb-6 pt-8 backdrop-blur-2xl bg-[#fff]`}
        >
          
          <div
            className={`flex flex-col w-11/12 sm:w-10/12 h-[2348px] sm:h-full relative items-start py-6 bg-white`}
          >
            
            <div className="flex flex-col mx-auto sm:h-screen sm:w-[1200px] bg-[#FFFFFF] rounded-xl  mt-10">
              <span
                className="font-bold text-[16px] m-[24px] text-[#A1A1A1] cursor-pointer flex flex-row font-raleway"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIosIcon />Go Back
              </span>
              <div className="flex flex-row w-full">
                <h1 className="font-bold text-xl pl-6 mr-auto font-raleway">
                  Saved Resources
                </h1>
              </div>

              {/* <div className="flex flex-row my-[24px] border-y-[1px] border-[#E9E9E9] h-[67px] py-2">
                {savedResourcePageOptions.map((option, i) => (
                  <div
                    key={i}
                    className={`${
                      currentOption === option.id
                        ? "border-0 bg-primaryDark-0 text-white"
                        : "cursor-pointer border-[1px] text-[#4D4D4D] border-[#E9E9E9]"
                    }  p-2 my-auto mx-6 rounded-lg font-raleway`}
                    onClick={() => setCurrentOption(option.id)}
                  >
                    {option.name}
                  </div>
                ))}
              </div> */}
                <>
                  {filteredSavedResources && (
                    <Pagination
                      currentPage={currentPage}
                      totalItems={numSavedResources}
                      startIndex={startIndex}
                      endIndex={endIndex}
                      onPageChange={setCurrentPage}
                      itemsPerPage={itemsPerPage}
                    />
                  )}

                  <div className="flex flex-col mx-auto sm:h-screen sm:w-[1200px] bg-[#fff] rounded-xl">
                    {isLoadingSavedResources ? (
                      <div className="flex flex-row justify-evenly font-light text-center text-[#013847]/60 text-xs sm:text-sm py-8">
                        Loading saved resources...
                      </div>
                    ) : paginatedResources && paginatedResources.length > 0 ? (
                      paginatedResources.map((resource: SavedResourceSchema, i: number) => (
                        <SavedResourceCard
                          key={resource.resource_id || resource.id || i}
                          isMobile={false}
                          resource={resource}
                          handleRemoveSavedResource={handleRemoveSavedResource}
                        />
                      ))
                    ) : (
                      <div className="flex flex-row justify-evenly font-light text-center text-[#013847]/60 text-xs sm:text-sm">
                        No saved resources to show
                      </div>
                    )}
                  </div>
                </>
            </div>
          </div>
        </div>
        {/* <BookingDetailsModal
          booking={selectedBooking}
          isOpen={isBookingModalOpen}
          isEditMode={isEditMode}
          onClose={handleCloseBookingModal}
          // onSave={handleSaveBookingChanges} // implement this if needed
        /> */}
      </>
    );
};

export default SavedResourceListing;
